const tabButtons = document.querySelectorAll(".tablinks-cus");
const tabContents = document.querySelectorAll(".tabcontent-cus");
const scrollContainer1 = document.querySelector(".tablinks-cus__wrapper");
const alltabsbutton = document.querySelectorAll(".tablinks-cus__wrapper button");
const scrollAmount1 = 200;
let totalwidth = 0;
for(i = 0; i < alltabsbutton.length; i++){
  totalwidth += alltabsbutton[i].offsetWidth;
}
totalwidth = totalwidth-200;
tabButtons.forEach((tabButton) => {
  tabButton.addEventListener("click", (e) => {
    tabButtons.forEach((newTabButton) => {
      newTabButton.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
  const tabButtonId = e.currentTarget.offsetLeft;
    const nextElementOffsetLeft = e.currentTarget.nextElementSibling.offsetWidth;
    // console.log(tabButtonId,nextElementOffsetLeft)
 // var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 //        console.log(tabButtonId);
 //    if(screenWidth < 768){
 //       scrollContainer1.scrollLeft = tabButtonId-30;
    
 //    }else{
       scrollContainer1.scrollLeft = tabButtonId-300;
       
    setTimeout(function(){ 
      const scrlleft = scrollContainer1.scrollLeft+150;
      // console.log(tabButtonId+"----"+scrlleft +'>'+ totalwidth+"=="+scrollContainer1.scrollLeft);
    if(tabButtonId > 800){
      document
    .querySelector(".tablinks-cus__outer_wrapper .right_arrow").classList.add("disable");
    }else{
       document
    .querySelector(".tablinks-cus__outer_wrapper .right_arrow").classList.remove("disable");
    }
     if(tabButtonId <= 50){
      document
    .querySelector(".tablinks-cus__outer_wrapper .left_arrow").classList.add("disable");
    }else{
       document
    .querySelector(".tablinks-cus__outer_wrapper .left_arrow").classList.remove("disable");
    }
    },300);  
   // }
   
         if (    
    tabButton.nextElementSibling.tagName.toLowerCase() !== 'button') {
  document.querySelector(".tablinks-cus__outer_wrapper .right_arrow").classList.add("disable");
}
   tabContents.forEach((tabContent) => {
  if (tabContent.getAttribute("id") == e.currentTarget.dataset.tabButtonId) {
    tabContents.forEach((newTabContent) => {
      // newTabContent.style.display = "none";
      newTabContent.classList.remove("Show_content");
    });

    // tabContent.style.display = "block";
    tabContent.classList.add("Show_content"); 
  }
});
  });
});

tabButtons[0].classList.add("active");
// tabContents[0].style.display = "block";
tabContents[0].classList.add("Show_content");
var rightscroll = 9999999999;
var leftscroll = 0;
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelector(".tablinks-cus__outer_wrapper .left_arrow").classList.add("disable");
  let scrollContainer = document.querySelector(".tablinks-cus__wrapper");
  let scrollAmount = 200;

  document
    .querySelector(".tablinks-cus__outer_wrapper .left_arrow")
    .addEventListener("click", function () {
      // console.log(0 +'<'+ (scrollContainer.scrollLeft - scrollAmount));
     rightscroll = scrollContainer.scrollLeft - scrollAmount - 200;
      document
    .querySelector(".tablinks-cus__outer_wrapper .right_arrow").classList.remove("disable");
     leftscroll = 0;
      scrollContainer.scrollLeft -= scrollAmount;
      
      document
        .querySelectorAll(".tablinks-cus.active")
        .forEach((activeButtonElement) => {
          const tabButton_id = activeButtonElement.previousElementSibling.offsetLeft;
          activeButtonElement.previousElementSibling.classList.add("active");
          activeButtonElement.classList.remove("active");
          tabContents.forEach((tabContent) => {
            if (
              tabContent.getAttribute("id") ==
              activeButtonElement.dataset.tabButtonId
            ) {
              tabContents.forEach((newTabContent) => {
                // newTabContent.style.display = "none";
                newTabContent.classList.remove("Show_content");
              });
              // tabContent.previousElementSibling.style.display = "block";
              tabContent.previousElementSibling.classList.add("Show_content");
            }
          });
          if(0 >= tabButton_id){   
           document.querySelector(".tablinks-cus__outer_wrapper .left_arrow").classList.add("disable");
         }
          
        });

      tabButtons.forEach((link) => {
        if(link.classList.contains("active")) {
          const underline = document.querySelector(".nav-underline");
          underline.style.width = link.offsetWidth + "px";
          underline.style.left = link.offsetLeft + "px";
        }
      });
      // console.log( scrollContainer.scrollLeft -= scrollAmount)
     
    });

  document
    .querySelector(".tablinks-cus__outer_wrapper .right_arrow")
    .addEventListener("click", function () {
      // console.log(totalwidth +'>'+ (scrollContainer.scrollLeft + scrollAmount));
    
        document
    .querySelector(".tablinks-cus__outer_wrapper .left_arrow").classList.remove("disable");
        rightscroll = 99999999999;
      leftscroll = scrollContainer.scrollLeft + scrollAmount+199;
      // console.log(leftscroll);
      scrollContainer.scrollLeft += scrollAmount;
      document
        .querySelectorAll(".tablinks-cus.active")
        .forEach((activeButtonElement) => {
          var tabButton_Id = activeButtonElement.offsetLeft;
          activeButtonElement.nextElementSibling.classList.add("active");
          activeButtonElement.classList.remove("active");
          tabContents.forEach((tabContent) => {
            if (
              tabContent.getAttribute("id") ==
              activeButtonElement.dataset.tabButtonId
            ) {
              tabContents.forEach((newTabContent) => {
                // newTabContent.style.display = "none";
                newTabContent.classList.remove("Show_content");
              });
              // tabContent.nextElementSibling.style.display = "block";
              if(tabContent.nextElementSibling){
              tabContent.nextElementSibling.classList.add("Show_content");
              }
            }
          });

         /* if(750 < tabButton_Id){
            
          }*/
          console.log(activeButtonElement.nextElementSibling)
          if (    
    activeButtonElement.nextElementSibling.nextElementSibling.tagName.toLowerCase() !== 'button') {
  document.querySelector(".tablinks-cus__outer_wrapper .right_arrow").classList.add("disable");
}
        });

      tabButtons.forEach((link) => {
        if(link.classList.contains("active")) {
          const underline = document.querySelector(".nav-underline");
          underline.style.width = link.offsetWidth + "px";
          underline.style.left = link.offsetLeft + "px";
        }
      });
      
    });

  let windowWidth = window.innerWidth;

  if (windowWidth > 768) {
    let navLinks = document.querySelectorAll(
      ".tablinks-cus__wrapper .tablinks-cus"
    );
    let arrows = document.querySelectorAll(
      ".tablinks-cus__outer_wrapper .tab_arrow_wrapper"
    );

    if (navLinks.length > 3) {
      arrows.forEach(function (arrow) {
        arrow.style.display = "flex";
      });
    } else {
      arrows.forEach(function (arrow) {
        arrow.style.display = "none";
      });
    }
  }
});
